import React from 'react'
import { Column, Box, View, Row, SectionIntro } from 'components/Layout'
import { Button } from 'components/Button'
import { Image } from 'components/Image'

import letsBuild from '../../assets/intros/girl-build.png'
// import letsExplore from '../../assets/intros/girl-pinning.png'
import letsExplore from '../../assets/intros/girl-snorkeling.png'

import { FirstLoginIntro } from '../../containers'
import history from '../../history'

const Home = () => (
	<View>
		<Row topMargin>
			<Column width={9}>
				<FirstLoginIntro />
			</Column>
		</Row>
		<Row>
			<Column width={5}>
				<Box
					dark
					bodyPadding
					body={
						<div>
							<Image
								src={letsBuild}
								width={150}
								height={280}
								style={{
									float: 'right',
									marginRight: '-30px',
									marginBottom: '-30px'
								}}
							/>
							<SectionIntro
								light
								header={'Build'}
								body={
									'Go ahead and create your apps here. We’ll guide you by the hand, no worries.'
								}
							/>
							<br />
							<Button
								size={'large'}
								onClick={() => {
									history.push('/apps')
								}}
							>
								{'Go to apps'}{' '}
							</Button>
						</div>
					}
				/>
			</Column>
			<Column width={5}>
				<Box
					bodyPadding
					body={
						<div>
							<Image
								src={letsExplore}
								width={150}
								height={280}
								style={{
									float: 'right',
									marginBottom: '-30px'
								}}
							/>
							<SectionIntro
								header={'Explore'}
								body={
									'Dive into the chat.io docs and articles to get inspired for your next project.'
								}
							/>
							<br />
							<Button
								type={'ghost'}
								size={'large'}
								onClick={() => {
									history.push('/explore')
								}}
							>
								{'Start exploring'}
							</Button>
						</div>
					}
				/>
			</Column>
		</Row>
		<Row>
			<Column width={6}>
				<Box
					bodyPadding
					body={
						<div>
							<SectionIntro
								header={'Support & Feedback'}
								body={
									"If you got stuck at any point, please feel free to reach out for support. We're also interested in your feedback!"
								}
							/>
						</div>
					}
					footer={
						<span>
							<Button
								type={'ghost'}
								onClick={e => {
									const LC_API = window.LC_API || {}
									LC_API.open_chat_window()
								}}
							>
								{'Chat with us'}
							</Button>
						</span>
					}
				/>
			</Column>
			<Column width={4}>
				<Box
					bodyPadding
					body={
						<div>
							<SectionIntro
								header={'Discover chat.io'}
								body={
									'Check out the use cases to see what chat.io can do for you.'
								}
							/>
						</div>
					}
					footer={
						<a
							href="https://www.chat.io/platform"
							target="_blank"
							rel="noopener"
						>
							<Button type={'ghost'}>
								{'Start discovering'}
							</Button>
						</a>
					}
				/>
			</Column>
		</Row>
	</View>
)

export default Home



// WEBPACK FOOTER //
// ./src/views/Home/Home.js